/* Built In Imports */
/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import MediaEmbed from '@components/Embeds/MediaEmbed';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';

/**
 * Returns the Offered.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Offered component
 */

const videoViewed = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({
      event: 'EoE_Video_Viewed',
    });
  }
};
const Offered = ({ section, region, language }) => {
  const gtmClick = () => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'EoE_Video_Viewed',
    });
  };

  return (
    <Box fontSize="18px" bgColor="#693033" color="white" minH="530px">
      <Box
        display="flex"
        fontSize="18px"
        mx="auto"
        justifyContent={{ base: 'center', md: 'space-between' }}
        alignItems={{ base: 'center', md: 'left' }}
        textAlign={{ base: 'center', md: 'left' }}
        py={{ base: '38px', md: '82px' }}
        px={{ base: '16px', md: '30px', lg: '0px' }}
        w="full"
        flexDir={{ base: 'column', md: 'row' }}
        maxW="930px"
        gridGap={{ base: 0, md: '40px' }}
      >
        <Box maxW={{ base: '100%', lg: '421px' }}>
          <StructuredTextParser
            str={render(section?.sectionContent[0].body)}
            region={region}
            lang={language}
            mt="0px"
            className="offerHeading"
          />
          <Image
            alt="divider"
            loading="lazy"
            title="divider"
            minHeight="24px"
            mt="5px"
            src={`${config.staticPath}/d/46272/1663645555-flower-divider-horizontal.png`}
            m={{ base: '0 auto', md: '5px 0' }}
          />
          <StructuredTextParser
            str={render(section?.sectionContent[1].body)}
            region={region}
            lang={language}
            mt="0px"
            className="paragraphText"
          />
        </Box>
        <Box width={{ base: '100%', lg: '432px' }} onClick={() => videoViewed}>
          {/* <LazyLoadImageComponent
            src={section?.sectionContent[2]?.image?.url}
          /> */}

          <MediaEmbed
            sectionContent={section?.sectionContent[2]}
            onClick={() => {
              gtmClick();
            }}
            minHt={'auto'}
          />
        </Box>
      </Box>
      <style jsx global>
        {`
          .offerHeading p {
            font-size: 36px;
            font-family: 'FedraSansStd-A-medium';
            line-height: 46px;
          }
          .offerHeading p mark {
            color: #fbad2e;
            background: none;
          }
          .paragraphText {
            padding-top: 30px;
          }
          .paragraphText p {
            font-size: 16px;
            color: #fff;
            font-family: 'FedraSansStd-book';
            padding-bottom: 5px;
          }
          .paragraphText p:last-child {
            padding-bottom: 0px;
          }
          @media (max-width: 767px) {
            .paragraphText p:last-child {
              padding-bottom: 20px;
            }
            .paragraphText p {
              text-align: center;
            }
            .offerHeading p {
              font-size: 24px;
              line-height: 34px;
              text-align: center;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Offered;
